import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IPathsInfo } from "../../models/storeModels/IPath";
import { logout } from "../../features/auth";
import { getItemWebStorage } from "../../features/webStorageSaver";

function getInitialState() {
    const { selectedPath, pathsList, roadsList, idsOfPathsWithGeometry, roadRaionSegments } = getItemWebStorage('pathsInfo') ?? {}
    const initialState: IPathsInfo = {
        selectedPath,
        pathsList,
        roadsList,
        roadRaionSegments,
        idsOfPathsWithGeometry,
        pathsSearchValue: null
    }
    return initialState
}

export const pathsInfoSlice = createSlice({
    name: 'pathsInfo',
    initialState: getInitialState(),
    reducers: {
        setSelectedPath(state, action: PayloadAction<any>) {
            state.selectedPath = action.payload
        },
        setPathsList(state, action: PayloadAction<any>) {
            state.pathsList = action.payload
        },
        setRoadsList(state, action: PayloadAction<any>) {
            state.roadsList = action.payload
        },
        setRoadRaionSegments(state, action: PayloadAction<any>) {
            state.roadRaionSegments = action.payload
        },
        setIdsOfPathsWithGeometry(state, action: PayloadAction<any>) {
            state.idsOfPathsWithGeometry = action.payload
        },
        setPathsSearchValue(state, action: PayloadAction<any>) {
            state.pathsSearchValue = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { 
    setSelectedPath, 
    setPathsList, 
    setRoadsList, 
    setRoadRaionSegments,
    setIdsOfPathsWithGeometry,
    setPathsSearchValue
} = pathsInfoSlice.actions
export const pathsInfoReducer = pathsInfoSlice.reducer;
